// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"c04e0751e37a8da3","5285":"fa3954d5c0050954"}[chunkId] + ".css";
};